module.exports = __webpack_public_path__ + "img/icon_system_dictionary.9310fb71.svg";